const visitedPages = new Set<string>();

export function hasVisitedAiProficiencyPage(pageKey: string): boolean {
  return visitedPages.has(pageKey);
}

export function markAiProficiencyPageVisited(pageKey: string): void {
  visitedPages.add(pageKey);
}
